/* eslint linebreak-style: ["error", "unix"] */
import MailOutlineIcon from '@material-ui/icons/MailOutline';

export interface Member {
  name: string
  role: string
  description?: string
  image?: string
  socialLinks?: {
    icon: React.FC,
    to: string
  }[]
}

export const mesaAssembleiaGeral = [
  {
    name: 'Vicente Jardim',
    role: 'Presidente',
    image: '/images/team/vicenteJardim.jpg',
    /* socialLinks: [
      {
        icon: MailOutlineIcon,
        to: 'mailto:rui.valente@anjb.pt',
      },
    ], */
  },
  {
    name: 'Manuela Ribeiro',
    image: '/images/team/ManuelaRibeiro.jpg',
    role: 'Vice-presidente',
  },
  {
    name: 'Hélder Leal',
    image: '/images/team/HelderLeal.jpeg',
    role: 'Secretário',
  },
];

export const conselhoFiscal: Member[] = [
  {
    name: 'Claire Martins',
    role: 'Presidente',
    image: '/images/team/Claire.jpeg',
    /* socialLinks: [
      {
        icon: MailOutlineIcon,
        to: 'mailto:hugo.silva@anjb.pt',
      },
    ], */
  },
  {
    name: 'Miguel Costa',
    image: '/images/team/MiguelCosta.jpeg',
    role: 'Vogal',
  },
  {
    name: 'Daniela Curado',
    image: '/images/team/DanielaCurado.jpeg',
    role: 'Vogal',
  },
];

export const direcao: Member[] = [
  {
    name: 'Luiz Haas',
    role: 'Presidente',
    image: '/images/team/LuizHaas.jpeg',
    /* socialLinks: [
      {
        icon: MailOutlineIcon,
        to: 'mailto:rui.vieira@anjb.pt',
      },
    ], */
  },
  {
    name: 'Paulo Martins',
    image: '/images/team/PauloMartins1.jpg',
    role: 'Vice-presidente',
  },
  {
    name: 'Diogo Pinheiro',
    image: '/images/team/Diogo.jpeg',
    role: 'Tesoureiro',
  },
  {
    name: 'Pedro Ferreira',
    image: '/images/team/PedroFerreira.jpeg',
    role: 'Secretário',
  },
  {
    name: 'Bruna Silva',
    image: '/images/team/BrunaSilva.jpeg',
    role: 'Vogal',
  },
  {
    name: 'Marisa Gonçalves',
    image: '/images/team/Marisa.jpeg',
    role: 'Vogal',
  },
  {
    name: 'Nuno Proença',
    image: '/images/team/NunoProenca2.jpg',
    role: 'Vogal',
  },
];

export const suplentes: Member[] = [
  {
    name: 'Jorge Marques',
    role: 'Suplente',
    image: '/images/team/JorgeMarques.jpeg',
    /* socialLinks: [
      {
        icon: MailOutlineIcon,
        to: 'mailto:rui.vieira@anjb.pt',
      },
    ], */
  },
  {
    name: 'Rita Santos',
    image: '/images/team/RitaSantos.jpeg',
    role: 'Suplente',
  },
];
